export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/constant.js
// module id = 1435
// module chunks = 0